export const getBaseURL = (location: Location) => {
    const { protocol, hostname, port } = location;
    const portString = port ? `:${port}` : '';
    return `${protocol}//${hostname}${portString}`;
};
